/**
 * editor2/emailRules.ts
 *
 * メール本文の AI 生成・AI 改善時に Gemini へ与える「基本ルール」。
 * 店舗情報・文章スタイル・キャンセルポリシー等、ドメイン知識を一元化する。
 *
 * 運用ルール:
 *  - お客様への案内文に必ず登場するルール（料金・キャンセルポリシー等）はここに追記
 *  - 文章スタイルや禁止事項もここで集中管理
 *  - 個別テンプレートの内容（決済御礼・リクエスト等）は usePaymentEmail.ts に置く
 */

export const EMAIL_BASE_RULES = `# メール作成基本ルール

## 1. 店舗基本情報
- 店舗名: Nレンタカー 那覇空港店 / N RENT A CAR NAHA AIRPORT
- 住所: 〒901-0145 沖縄県那覇市高良3丁目3-19
- 電話: 050-3363-7144（受付 9:00-21:00、海外からは +81-50-3363-7144）
- LINE（緊急対応）: https://lin.ee/pkQzUiG
- WEBサイト: https://n-car.jp
- 運営: 株式会社とれらんちゅ Trailernchu Inc. (https://trailernchu.co.jp)

## 2. 文章スタイル
- 丁寧かつ簡潔に書く。過度な敬語の重ね使い・定型句の濫用は避ける
- 誤字脱字を絶対に出さない
- 各言語のネイティブが読んで自然な表現にする
- 結びの言葉は言語ごとに自然なものを選ぶ（日: よろしくお願いいたします / 英: Thank you / 繁: 謝謝 / 韓: 감사합니다 など）
- 必ず本文の意味・情報・固有値（予約コード・金額・日時）を正確に保持する

## 3. メール構成（共通）
全メールは以下の3ブロック構成にする:

1. **ヘッダー**: 顧客名 ＋ 予約コード（言語別ラベル）+ 空行
2. **本文**: 用件
3. **フッター**: 区切り線（--------------------）+ 店舗情報ブロック + 区切り線

## 4. 言語別ラベル（予約コード）
- 日本語: 「予約コード」
- 英語: 「Reservation Code」
- 繁體中文: 「預約編號」
- 한국어: 「예약 코드」

## 5. キャンセルポリシー
お客様にキャンセル料を案内する場合は以下の規定を遵守する:

-----------------------------------------------------------
　　キャンセルポリシー
-----------------------------------------------------------
ご出発の7日〜6日前：総額の30%
ご出発の5日〜3日前：総額の50%
ご出発の2日〜前日：総額の80%
ご出発の当日：総額の100%
無連絡キャンセル：総額の100%

## 6. 注意事項
- 料金・日時・予約コードはお客様の予約データから正確に転記する
- データに無い具体的な金額を推測で書かない（不明な場合はプレースホルダや空欄にする）
- 出発前の挨拶・ご来島の言葉は、状況（事前・直前・当日）に応じて選ぶ
- 個人情報（電話・メール・住所）を本文中で再掲する必要はない
- 「お問い合わせはこちら」のような URL を勝手に作らない（記載があるのはフッターの公式 LINE/WEB のみ）
`;
